import { createApi } from "@reduxjs/toolkit/query/react";
import { CUSTOMER_SELL_PRODUCT } from "@utils/constants/customer-sell-product.constants";
import { baseQueryWithReauth } from "@states/auth/auth.api";

export const customerSellProductApi = createApi({
  reducerPath: "customerSellProductApi",
  tagTypes: ["CustomerSellProduct"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllCustomerSellProducts: builder.query<
      any,
      {
        page?: number;
        limit?: number;
        status?: string;
        start_date?: string;
        end_date?: string;
        search?: string;
        customer_sell_product_code?: string;
      }
    >({
      query: ({
        page = 1,
        limit = 10,
        status,
        start_date,
        end_date,
        search,
        customer_sell_product_code,
      }) => {
        const queryParams: any = {
          url: CUSTOMER_SELL_PRODUCT.GET_ALL,
          params: { page, limit },
        };

        if (status) queryParams.params.status = status;
        if (start_date) queryParams.params.start_date = start_date;
        if (end_date) queryParams.params.end_date = end_date;
        if (search) queryParams.params.search = search;
        if (customer_sell_product_code)
          queryParams.params.customer_sell_product_code = customer_sell_product_code;

        return queryParams;
      },
      providesTags: ["CustomerSellProduct"],
    }),
    getCustomerSellProductById: builder.query<any, string | number>({
      query: (id) => ({
        url: `${CUSTOMER_SELL_PRODUCT.GET_ONE}${id}`,
      }),
      providesTags: ["CustomerSellProduct"],
    }),
    createCustomerSellProduct: builder.mutation<any, any>({
      query: (body) => ({
        url: CUSTOMER_SELL_PRODUCT.CREATE,
        method: "POST",
        body,
      }),
      invalidatesTags: ["CustomerSellProduct"],
    }),
    updateCustomerSellProduct: builder.mutation<any, { id: string | number; body: any }>({
      query: ({ id, body }) => ({
        url: `${CUSTOMER_SELL_PRODUCT.UPDATE}${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["CustomerSellProduct"],
    }),
    deleteCustomerSellProduct: builder.mutation<any, { id: string | number; body?: any }>({
      query: ({ id, body }) => ({
        url: `${CUSTOMER_SELL_PRODUCT.DELETE}${id}`,
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["CustomerSellProduct"],
    }),
  }),
  keepUnusedDataFor: 0,
});

export const {
  useGetAllCustomerSellProductsQuery,
  useGetCustomerSellProductByIdQuery,
  useCreateCustomerSellProductMutation,
  useUpdateCustomerSellProductMutation,
  useDeleteCustomerSellProductMutation,
} = customerSellProductApi;
